"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactForm = void 0;
var forms_service_ui_1 = require("@danfoss/forms-service-ui");
var app_1 = require("app");
var React = require("react");
var ContactForm_1 = require("../../Components/ContactForm");
var ContactLoadingPopupContent_1 = require("./ContactLoadingPopupContent");
var trackFormOpening = function () {
    // Remove trailing slash to handle cases with and without it
    var urlPath = window.location.pathname.replace(/\/$/, '');
    app_1.GTM.contactFormOpen({
        virtualPageUrl: urlPath + "/contact-form/virtual",
        virtualPageTitle: 'Contact Form | Danfoss',
        segment: '',
        subSegment: '',
        pageType: 'contactForm',
    });
};
var ContactForm = function (_a) {
    var contactId = _a.contactId, culture = _a.culture, dictionary = _a.dictionary, locationApiUrl = _a.locationApiUrl, formsServiceApiUrl = _a.formsServiceApiUrl, contactFormService = _a.contactFormService, onFormClose = _a.onFormClose;
    var _b = React.useState(null), contactData = _b[0], setContactData = _b[1];
    var _c = React.useState(false), showErrorMessage = _c[0], setShowErrorMessage = _c[1];
    var _d = React.useState({
        formAlias: null,
        companyNameUI: null,
    }), additionalData = _d[0], setAdditionalData = _d[1];
    app_1.useDidMount(function () {
        trackFormOpening();
        contactFormService.getContactById(contactId).then(function (_a) {
            var contact = _a[0];
            if (!contact) {
                setShowErrorMessage(true);
                return;
            }
            var contactType = contact.type, segments = contact.segments, country = contact.country, email = contact.email, companyName = contact.companyName;
            var formAlias = forms_service_ui_1.getFormAlias({ contactType: contactType, segments: segments, country: country, email: email });
            var hasContactForm = !!formAlias;
            if (!hasContactForm) {
                setShowErrorMessage(true);
                return;
            }
            setAdditionalData({ formAlias: formAlias, companyNameUI: companyName });
            setContactData(contact);
        }, function () {
            setShowErrorMessage(true);
        });
    });
    var formAlias = additionalData.formAlias, companyNameUI = additionalData.companyNameUI;
    var contactLoadingFormTitle = dictionary.formTitleMessage;
    var contactLoadedFormTitle = dictionary.formTitleMessage + " " + companyNameUI;
    var formTitle = React.useMemo(function () {
        if (showErrorMessage)
            return '';
        return contactData ? contactLoadedFormTitle : contactLoadingFormTitle;
    }, [contactData, contactLoadedFormTitle, contactLoadingFormTitle, showErrorMessage]);
    return (React.createElement(ContactForm_1.ContactFormPopup, { formAlias: formAlias, formTitle: formTitle, onModalExited: onFormClose, popupOpenedAriaLabel: dictionary.contactFormPopupOpenedLabel, closeButtonAriaLabel: dictionary.popupCloseBtnLabel }, function (contactFormState, setFormState) {
        return contactData ? (React.createElement(ContactForm_1.ContactFormPopupContent, { formAlias: formAlias, contactData: contactData, companyName: companyNameUI, formTitle: contactLoadedFormTitle, dictionary: dictionary, culture: culture, locationUrl: locationApiUrl, formServiceUrl: formsServiceApiUrl, contactFormState: contactFormState, setFormState: setFormState })) : (React.createElement(ContactLoadingPopupContent_1.ContactLoadingPopupContent, { showErrorMessage: showErrorMessage, genericErrorMessageText: dictionary.genericErrorMessage }));
    }));
};
exports.ContactForm = ContactForm;
exports.default = exports.ContactForm;
